<template>
  <el-select v-model="id" :size="size" :class="[custom]" :clearable="clearable" :disabled="disabled" :multiple="multiple" :filterable="true" :remote="false" placeholder="输入名称搜索" :remote-method="remoteMethod" :loading="loading" @change="selectChange">
    <el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.id">
      <span>{{ item.name}}</span>
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    value: "",
    clearable: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "small",
    },
    defaults: {
      type: Array,
      default: () => { return [] }
    },
    default: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      id: "",
      loading: false,
    }
  },
  created() {
    this.id = this.value;
  },
  mounted() {
    this.remoteMethod(this.value);
  },
  watch: {
    value: function (newValue) {
      this.id = newValue;
    },
    defaults() {
      this.setDatas();
    },
  },
  methods: {
    remoteMethod(query) {
      this.loading = true;
      let params = {
        "key": "",
        "pageIndex": 1,
        "pageSize": 100,
        "tenantCode":this.$root.tenantInfo.code,
      }
      this.list = [];
      this.https("get", this.$root.tenantInfo.code == '1' ? "/api/Tenant/GetTenantGroups" : "/api/Tenant/GetTenantGroupViewByTenantCode", params).then(res => {
        this.loading = false;
        this.list = res.response.data || [];
        this.setDatas();
      }).catch(res => {
        this.loading = false;
      })
    },
    selectChange(val) {
      this.$emit('input', val);
      if (!this.multiple) {
        let obj = this.list.find(item => val == item.id);
        this.$emit('change', obj);
      } else {
        let list = this.list.filter(item => val.indexOf(item.id) >= 0);
        this.$emit('change', list);
      }
    },
    setDatas() {
      this.defaults.map(item => {
        let index = this.list.findIndex(list => list.id == item.id);
        if (index < 0) {
          this.list.push(item);
        }
      })
    }
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/IndustryList.vue